export const SET_COLUMNS = 'sourceData/SET_COLUMNS';
export const ADD_COLUMN_TO_VISIBLE_COLUMNS_NAMES = 'sourceData/ADD_COLUMN_TO_VISIBLE_COLUMNS_NAMES';
export const REMOVE_COLUMN_FROM_VISIBLE_COLUMNS_NAMES = 'sourceData/REMOVE_COLUMN_FROM_VISIBLE_COLUMNS_NAMES';
export const SET_RECOMMENDED_DATATYPES_TO_COLUMNS = 'sourceData/SET_RECOMMENDED_DATATYPES_TO_COLUMNS';

export const SET_ROWS = 'sourceData/SET_ROWS';

export const GET_JSON_DATA_REQUEST = 'sourceData/GET_JSON_DATA_REQUEST';

export const SET_ATTRIBUTE_TYPE = 'sureceData/SET_ATTRIBUTE_TYPE';

export const FILE_PATHS = [
    {
        name: 'Antibiotics dataset from 50\'s ',
        path: '/antibiotics.json'
    },
    {
        name: 'Movies dataset',
        path: '/movies.json'
    },
    {
        name: 'Cars statistics from 1970 to 1982',
        path: '/cars.json'
    }
];
